<div class="grid grid-cols-12 gap-4">
  <div class="col-span-6">
    <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-gauge icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <span class="text-grey"> Threat Score </span>
        <span class="text-2xl">
          {{ !!threatGroup?.threat_score ? (threatGroup.threat_score | threatScorePipe) + '/10' : '-' }}
        </span>
        <span
          [ngClass]="{
            'text-green': threatGroup?.threat_score < 4,
            'text-orange': threatGroup?.threat_score >= 4 && threatGroup?.threat_score < 8,
            'text-red': threatGroup?.threat_score >= 8
          }">
          {{
            threatGroup?.threat_score < 4
              ? 'Low Severity'
              : threatGroup?.threat_score >= 4 && threatGroup?.threat_score < 8
                ? 'Medium Severity'
                : threatGroup?.threat_score >= 8
                  ? 'High Severity'
                  : '-'
          }}
        </span>
      </div>
    </microsec-card>
  </div>
  <div class="col-span-6" (click)="openDeviceTabEvent ? openDeviceTabEvent.emit() : null">
    <microsec-card styleClass="detail-card cursor-pointer rounded-lg" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-square-up-right icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <span class="text-grey">Impacted Device</span>
        <span class="text-2xl"> {{ threatGroup?.devices?.length || 0 }} {{ threatGroup?.devices?.length > 1 ? 'Devices' : 'Device' }} </span>
        <div class="overflow-hidden whitespace-nowrap text-ellipsis">
          <ng-container *ngFor="let device of threatGroup?.devices || []; let lastDevice = last">
            <span class="text-grey"> {{ device.label }}<span *ngIf="!lastDevice">,</span> </span>
          </ng-container>
        </div>
      </div>
    </microsec-card>
  </div>

  <div class="col-span-12">
    <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-biohazard icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold">Threat Group Details</label>

        @if (threatGroup.threat_type !== THREAT_TYPES.NON_COMPLIANCE) {
          <label class="!capitalize text-2xl">
            {{ threatGroup?.attack_type ? (threatGroup.attack_type | constant: 'threat-attack-type') : '-' }}
          </label>

          @if (!!threatGroup.descriptionPreview) {
            <span class="text-grey markdown-preview" [innerHTML]="threatGroup.descriptionPreview"></span>
          }
        } @else {
          <label class="!capitalize text-2xl">
            {{ threatGroup?.non_compliance_category ? (threatGroup.non_compliance_category | uppercase) : '-' }}
          </label>

          <span class="text-grey">
            {{
              threatGroup.threat_type === THREAT_TYPES.NON_COMPLIANCE
                ? 'MicroIDS has detected non-compliance from the following assessment(s).'
                : 'MicroIDS has detected suspicious and unusual behavior that may indicate ' +
                  THREAT_TYPE_DESCRIPTIONS[threatGroup.threat_type] +
                  ' in your network.'
            }}
          </span>
        }

        <div class="list-fields mx-4">
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-4 font-bold"> Start Date </label>
            <label class="col-span-8 text-grey"> {{ threatGroup?.created | momentPipe }} </label>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-4 font-bold"> End Date </label>
            <label class="col-span-8 text-grey"> {{ threatGroup?.updated | momentPipe }} </label>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="threatGroup?.updatableStatus">
            <label class="col-span-4 font-bold items-center">
              <span>Status</span>
              <span
                class="pi pi-info-circle ml-2"
                pTooltip="Use status to track threat progress.<br/><br/> Setting status to 'Closed (False Alarm)' helps MicroIDS improve detection accuracy and reduce similar alerts."
                [escape]="false"
                tooltipPosition="top"
                appendTo="body"></span>
            </label>
            <div class="col-span-8">
              <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="right" appendTo="body">
                <p-select
                  class="status-dropdown bordered-dropdown uppercase"
                  [ngClass]="{
                    'red-dropdown': threatGroup.updatableStatus.toLowerCase() === 'open' && threatGroup.updatableIsTruePositive === null,
                    'orange-dropdown': threatGroup.updatableStatus.toLowerCase() === 'fixing' && threatGroup.updatableIsTruePositive === true,
                    'green-dropdown': threatGroup.updatableStatus.toLowerCase() === 'closed' && threatGroup.updatableIsTruePositive === true,
                    'grey-dropdown': threatGroup.updatableStatus.toLowerCase() === 'closed' && threatGroup.updatableIsTruePositive === false
                  }"
                  [options]="threatStatusOptions"
                  optionLabel="label"
                  appendTo="body"
                  (onChange)="
                    changeStatusEvent
                      ? changeStatusEvent.emit({ value: $event.value, threatGroups: [threatGroup], statusOption: $event.value })
                      : null
                  "
                  [disabled]="!permissions[USER_ROLE.TECHNICIAN] || !!threatGroup.is_imported || !isValidLicense()">
                  <ng-template #selectedItem>
                    <div [pTooltip]="threatGroup | constant: 'threat-status-tooltip'" tooltipPosition="top" appendTo="body">
                      @if (threatGroup.updatableStatus.toLowerCase() === 'closed') {
                        @if (!!threatGroup.updatableIsTruePositive) {
                          <span class="fa fa-circle-check mr-1"></span>
                        } @else {
                          <span class="fa fa-bell-slash mr-1"></span>
                        }
                      }
                      <span>{{ threatGroup | constant: 'threat-status' }}</span>
                    </div>
                  </ng-template>
                </p-select>
              </span>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threatGroup.snort_rule_id">
            <label class="col-span-4 font-bold"> Snort Rule ID </label>
            <div class="col-span-8">
              <p-chip
                class="cursor-pointer"
                [label]="threatGroup.snort_rule_id"
                (click)="openSnortUrl(threatGroup.snort_rule_id)"
                tooltipPosition="right"
                appendTo="body" />
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="threatGroup?.attack_technique">
            <label class="col-span-4 font-bold"> Technique Name </label>
            <label class="col-span-8 text-grey"> {{ threatGroup.attack_technique }} </label>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="threatGroup?.mitre_technique_id">
            <label class="col-span-4 font-bold"> MITRE Technique ID </label>
            <div class="col-span-8">
              <p-chip
                class="cursor-pointer"
                [label]="threatGroup.mitre_technique_id"
                (click)="openUrl('https://attack.mitre.org/techniques/' + threatGroup.mitre_technique_id.split('.').join('/'))" />
            </div>
          </div>
        </div>
      </div>
    </microsec-card>
  </div>

  <div class="col-span-12">
    <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-chart-column icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold"> Insights </label>
        <div class="text-center">
          <p-selectButton
            class="custom-selectbutton"
            [allowEmpty]="false"
            [options]="detailsViewOptions"
            [(ngModel)]="selectedDetailsView"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false" />
        </div>

        <div class="list-fields mx-4">
          @switch (selectedDetailsView) {
            @case ('timeline') {
              <div class="px-20 h-80 overflow-y-auto">
                <p-timeline [value]="threats" styleClass="custom-timeline">
                  <ng-template #content let-event>
                    <div class="timeline-card cursor-pointer rounded-lg p-4" (click)="selectedThreat = event">
                      <div class="flex flex-col gap-2">
                        <span class="text-grey text-sm">{{ event.created | momentPipe }}</span>
                        <span class="flex gap-2">
                          <span class="text-bold text-lg font-bold">
                            {{ event.threat_type | constant: 'threat-type' }}
                          </span>
                          @if (event.threat_type !== THREAT_TYPES.NON_COMPLIANCE) {
                            <span class="text-bold text-lg font-bold"> ({{ event.attack_type | constant: 'threat-attack-type' }}) </span>
                          } @else {
                            <span class="text-bold text-lg font-bold"> ({{ event.non_compliance_category | uppercase }}) </span>
                          }
                        </span>
                        <span class="text-grey text-sm" *ngIf="!!event.description">{{ event.description }}</span>
                      </div>
                    </div>
                  </ng-template>
                </p-timeline>
              </div>
            }
            @case ('frequency') {
              @if (!!threatGroup?.threats?.length && !!charts[selectedDetailsView]) {
                <div style="height: 20rem">
                  <p-chart type="line" [data]="charts[selectedDetailsView].data" [options]="charts[selectedDetailsView].options" />
                </div>
              } @else {
                <div class="flex" style="height: '20rem'">
                  <label class="m-auto">No data found</label>
                </div>
              }
            }
            @case ('devices') {
              @if (!!threatGroup?.devices?.length && !!charts[selectedDetailsView]) {
                <div style="height: 20rem">
                  <p-chart type="bar" [data]="charts[selectedDetailsView].data" [options]="charts[selectedDetailsView].options" />
                </div>
              } @else {
                <div class="flex" style="height: 20rem">
                  <label class="m-auto">No data found</label>
                </div>
              }
            }
          }
        </div>
      </div>
    </microsec-card>
  </div>

  <div class="col-span-12" *ngIf="!!threatGroup?.connection_id || !!threatGroup?.analyzer_id">
    <microsec-card styleClass="detail-card rounded-lg" [isNestedCard]="true" [isFull]="true">
      <div class="card-icon icon-container">
        <i class="fas fa-bars icon"></i>
      </div>
      <div class="flex flex-col gap-4">
        <label class="font-bold">Other Information</label>
        <div class="list-fields mx-4">
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threatGroup?.connection_id">
            <label class="col-span-4 font-bold"> Network Connection </label>
            <div class="col-span-8">
              <p-chip
                class="cursor-pointer"
                [label]="'Connection ID: ' + threatGroup.connection_id"
                (click)="goToConnectionPage(threatGroup.connection_id)"></p-chip>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 items-center" *ngIf="!!threatGroup?.analyzer_id">
            <label class="col-span-4 font-bold"> Analyzer </label>
            <div class="col-span-8">
              <p-chip
                class="cursor-pointer"
                [label]="'Analyzer ID: ' + threatGroup.analyzer_id"
                (click)="
                  goToAnalyzerPage(threatGroup.analyzer_id, !!threatGroup.snort_rule_id || threatGroup.attack_type?.toLowerCase() === 'unknown')
                "></p-chip>
            </div>
          </div>
        </div>
      </div>
    </microsec-card>
  </div>
</div>

<p-drawer
  [(visible)]="displayThreatDetails"
  [showCloseIcon]="false"
  [style]="{ width: '50rem' }"
  position="right"
  appendTo="body"
  [baseZIndex]="998"
  (onHide)="selectedThreat = null">
  @if (!!selectedThreat && !!displayThreatDetails) {
    <app-threat-details [threatId]="selectedThreat.threat_id" (hidePanelEvent)="selectedThreat = null" />
  }
</p-drawer>
